import { makeStyles } from 'tss-react/mui'
import bg from 'src/assets/images/aboutUs/notalonebg.jpg'
import { lato, nunito_sans } from '@styles/fonts'
const useStyles = makeStyles()((theme) => ({
  rootContainer: {
    backgroundImage: `url(${bg?.src})`,
    backgroundSize: '100% 100%',
    padding: theme.spacing(30, 0, 20, 0),
    borderRadius: '60px',
    color: 'white',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(10, 0, 10, 0),
    },
  },
  rootZenContainer: {
    background: 'none',
    border: '1px solid black',
    color: 'black',
  },
  textContainer: {
    padding: theme.spacing(0, 18),
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      padding: theme.spacing(0, 7),
    },
  },
  heading: {
    fontFamily: nunito_sans.style.fontFamily,
    fontSize: '72px',
    lineHeight: '83px',
    fontWeight: 800,
    marginBottom: theme.spacing(6),
    textTransform: 'uppercase',
    [theme.breakpoints.down('md')]: {
      fontSize: '32px',
      lineHeight: '43.65px',
    },
  },
  text: {
    fontFamily: lato.style.fontFamily,
    fontWeight: 400,
    fontSize: '20px',
    lineHeight: '24px',
    marginBottom: theme.spacing(15),
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      lineHeight: '16.8px',
    },
  },
}))

export default useStyles
